// import logo from './logo.svg';
import './Sass/main.sass'
// import './Sass/includes/Components/modules/countries.sass'
import ModulosPeopleContainer from "./Containers/People/Modules";

// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import {store, persistorStore} from './Store'
// import AppRouter from "./Router";

function App() {
  return (
    <div className="App">
      <ModulosPeopleContainer />
      {/* <AppRouter /> */}
    </div>
    // <Provider store={store}>
    // <PersistGate loading={null} persistor={persistorStore}>
    // </PersistGate>
    // </Provider>
  );
}

export default App;
